<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="icon-youtube"
    :width="width"
    :height="height"
    :fill="fill"
    viewBox="0 0 30 21"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.2257 1.09737C27.4557 1.42662 28.4223 2.39323 28.7516 3.62324C29.3489 5.85042 29.3514 10.5 29.3514 10.5C29.3514 10.5 29.3514 15.1496 28.754 17.3768C28.4247 18.6068 27.4582 19.5734 26.2281 19.9026C24.0009 20.5 15.0662 20.5 15.0662 20.5C15.0662 20.5 6.13167 20.5 3.90449 19.9026C2.67448 19.5734 1.70787 18.6068 1.37861 17.3768C0.78125 15.1496 0.78125 10.5 0.78125 10.5C0.78125 10.5 0.78125 5.85042 1.37626 3.62324C1.70552 2.39323 2.67448 1.42662 3.90213 1.09737C6.12932 0.5 15.0639 0.5 15.0639 0.5C15.0639 0.5 23.9986 0.5 26.2257 1.09737ZM19.627 10.5004L12.207 14.7854V6.21533L19.627 10.5004Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "../mixins/icons";

export default {
  name: "IconYoutube",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
